import React from 'react'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { BiBarcodeReader } from 'react-icons/bi'

const AssetScanButton = (props) => {
  const { t } = useTranslation()

  return (
    <Button {...props}>
      <BiBarcodeReader className='me-2' size={22} />
      {t('assetPage:assetScan')}
    </Button>
  )
}

export default AssetScanButton